<template>
  <div />
</template>

<script>

/**
 * Vue: klaviyo footer (klaviyo-footer)
 * -----------------------------------------------------------------------------
 * Klaviyo Footer signup.
 *
 */
export default {
  name: 'KlaviyoFooter',

  data() {
    return {
      cnvsGlobal: true,
      nodeSelectors: null,
      state: 'IDLE',
    }
  },

  mounted() {
    this.setSelectors()
    this.setEventListeners()
  },

  methods: {

    /**
     * Sets the event listeners
     */
    setEventListeners() {
      this.nodeSelectors.form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.handleSubmit()
      })
    },

    /**
     * Sets the selectors
     */
    setSelectors() {
      const nodeSelectors = {
        input: document.querySelector('[js-klaviyo-footer="input"]'),
        submit: document.querySelector('[js-klaviyo-footer="submit"]'),
        form: document.querySelector('[js-klaviyo-footer="form"]'),
        checkbox: document.querySelector('[js-klaviyo-footer="checkbox"]'),
        error: document.querySelector('[js-klaviyo-footer="error"]'),
        success: document.querySelector('[js-klaviyo-footer="success"]'),
      }

      this.nodeSelectors = nodeSelectors
    },

    /**
     * Checks if an email address is valid
     * @param {String} email - the email address
     */
    validEmail(email) {
      // eslint-disable-next-line prefer-named-capture-group, no-useless-escape
      const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      return emailRegex.test(email)
    },

    /**
     * Handles the submission of the form to Klaviyo
     */
    async handleSubmit() {
      const errorMsg = this.nodeSelectors.error
      const success = this.nodeSelectors.success
      const form = this.nodeSelectors.form

      if (this.state === 'LOADING') {
        return
      }

      if (!this.nodeSelectors.checkbox.checked) {
        errorMsg.innerText = this.$string('klaviyo_messages.terms_error')
        errorMsg.classList.toggle('hidden', false)
        return
      }

      if (!this.validEmail(this.nodeSelectors.input.value)) {
        errorMsg.innerText = this.$string('klaviyo_messages.email_error')
        errorMsg.classList.toggle('hidden', false)
        return
      }

      this.state = 'LOADING'

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        })

        if (response.status === 200) {
          this.status = 'SUCCESS'
          errorMsg.classList.toggle('hidden', true)
          success.classList.toggle('hidden', false)
          form.classList.toggle('hidden', true)

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'newsletter_sign_up',
            sign_up_type: 'Footer',
          })

          return
        }

        reportError('Error with Klaviyo footer')
        errorMsg.classList.toggle('hidden', false)
      } catch (err) {
        reportError('Error with Klaviyo footer', err)
        errorMsg.classList.toggle('hidden', false)
      }
    },
  },
}
</script>
